import React from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import './headerDetails.css'
import { HEADER_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function SalaryUploadHeaderDetails({ option = {} }) {
  const { t } = useTranslation()
  return (
    <div className='approval-card-header'>
      <span>
        <span className='span1'>
          {t(HEADER_DETAILS_KEYS.FILE_NAME)} : {option?.file}
        </span>
        <span className='mt-2 span2'>
          {t(HEADER_DETAILS_KEYS.SOURCE_ACCOUNT_NO)} : {option?.srcAccNo}
        </span>
        <span className='mt-2 span2'>
          {t(HEADER_DETAILS_KEYS.BRANCH_CODE)} : {option?.srcAccBrn}
        </span>
      </span>
      <span>
        {option?.typeofFile === 'N' && (
          <span className='span3'>
            {`${t(HEADER_DETAILS_KEYS.TOTAL_AMOUNT)} :`} {option?.totalAmount}
          </span>
        )}

        <span className='mt-2 span2 text-right'>
          {option?.initDate !== null ? option?.initDate : '-'}
        </span>
      </span>
    </div>
  )
}
